import React, { useState } from "react";
const Module1 = () => {
  // Initialize the object state with its default properties.
  const initialPersonState = {
    firstName: "",
    lastName: "",
    age: 0,
    gender: "male", // Default value for radio button
    isStudent: false,
  };

  const [person, setPerson] = useState(initialPersonState);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;

    setPerson((prevState) => ({
      ...prevState,
      [name]: name === "age" ? parseInt(inputValue, 10) : inputValue,
    }));
  };
  const handleClear = () => {
    setPerson(initialPersonState);
  };
  return (
    <div>
      <input
        type="text"
        name="firstName"
        value={person.firstName}
        onChange={handleInputChange}
        placeholder="First Name"
      />
      <input
        type="text"
        name="lastName"
        value={person.lastName}
        onChange={handleInputChange}
        placeholder="Last Name"
      />
      <input
        type="number"
        name="age"
        value={person.age}
        onChange={handleInputChange}
        placeholder="Age"
      />

      <label>
        <input
          type="radio"
          name="gender"
          value="male"
          checked={person.gender === "male"}
          onChange={handleInputChange}
        />
        Male
      </label>

      <label>
        <input
          type="radio"
          name="gender"
          value="female"
          checked={person.gender === "female"}
          onChange={handleInputChange}
        />
        Female
      </label>

      <label>
        <input
          type="checkbox"
          name="isStudent"
          checked={person.isStudent}
          onChange={handleInputChange}
        />
        Is Student
      </label>

      <button onClick={handleClear}>Clear</button>

      <p>{`Name: ${person.firstName} ${person.lastName}, Age: ${person.age}, Gender: ${person.gender}, Is Student: ${person.isStudent}`}</p>
    </div>
  );
};

export default Module1;
